import { render, staticRenderFns } from "./FeaturedIndustries.vue?vue&type=template&id=13b9d364&scoped=true&"
import script from "./FeaturedIndustries.vue?vue&type=script&lang=js&"
export * from "./FeaturedIndustries.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedIndustries.vue?vue&type=style&index=0&id=13b9d364&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b9d364",
  null
  
)

export default component.exports